import OperationsDashboardView from 'src/sections/admin/dashboard-operations/view/operations-dashboard-view';
import Head from 'src/components/head';
import { useLocales } from 'src/locales';

export default function OperationsDashboardPage() {
  const { t } = useLocales('operativaDashboard');
  return (
    <>
      <Head title={t('operativa')} />
      <OperationsDashboardView />
    </>
  );
}
